import { useEffect, useState } from "react";
import {
  Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { maintenanceService, vehicleService } from "@/services/api";
import { toast } from "sonner";

const SERVICE_TYPES = [
  { value: "oil_change", label: "Oil change" },
  { value: "tire_rotation", label: "Tire rotation" },
  { value: "inspection", label: "Inspection" },
];

export function AddMaintenanceDialog({ open, onOpenChange, onSaved }) {
  const [vehicles, setVehicles] = useState([]);
  const [vehicleId, setVehicleId] = useState("");
  const [serviceType, setServiceType] = useState("oil_change");
  const [intervalKm, setIntervalKm] = useState("");
  const [intervalDays, setIntervalDays] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    setVehicleId(""); setIntervalKm(""); setIntervalDays("");
    vehicleService.list().then(setVehicles).catch(() => setVehicles([]));
  }, [open]);

  const submit = async (e) => {
    e.preventDefault();
    if (!vehicleId || (!intervalKm && !intervalDays)) {
      toast.error("Choose a vehicle and at least one interval");
      return;
    }
    setSaving(true);
    try {
      await maintenanceService.create({ vehicleId, serviceType, intervalKm, intervalDays });
      toast.success("Maintenance schedule added");
      onOpenChange(false);
      onSaved?.();
    } catch (err) {
      toast.error(err.response?.data?.error || "Could not add schedule");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader><DialogTitle>Add Maintenance Schedule</DialogTitle><DialogDescription>Set a recurring interval and ARC Beacon will flag it when due.</DialogDescription></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label>Vehicle</Label>
            <Select value={vehicleId} onValueChange={setVehicleId}>
              <SelectTrigger><SelectValue placeholder="Choose a vehicle" /></SelectTrigger>
              <SelectContent>{vehicles.map((v) => <SelectItem key={v.id} value={v.id}>{v.name}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div className="space-y-1.5">
            <Label>Service type</Label>
            <Select value={serviceType} onValueChange={setServiceType}>
              <SelectTrigger><SelectValue /></SelectTrigger>
              <SelectContent>{SERVICE_TYPES.map((s) => <SelectItem key={s.value} value={s.value}>{s.label}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1.5"><Label>Every (km)</Label><Input type="number" placeholder="e.g. 8000" value={intervalKm} onChange={(e) => setIntervalKm(e.target.value)} /></div>
            <div className="space-y-1.5"><Label>Every (days)</Label><Input type="number" placeholder="e.g. 180" value={intervalDays} onChange={(e) => setIntervalDays(e.target.value)} /></div>
          </div>
          <DialogFooter>
            <Button type="button" variant="secondary" onClick={() => onOpenChange(false)}>Cancel</Button>
            <Button type="submit" disabled={saving}>{saving ? "Adding…" : "Add Schedule"}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
